const { gql } = require("@apollo/client");

const ANALYTICS_STATION_GROUPS_QUERY = gql`
  query analyticsStationGroupsQuery(
    $timestamp: String!
    $groupBys: [String!]
  ) {
    analyticsStationGroups(
      input: {
        timestamp: $timestamp
        groupBys: $groupBys
      }
    ) {
      groups {
        parentGroup
        childGroups {
          name
          stationsCount
          stationIds
          groupId
        }
      }
    }
  }
`

export {
  ANALYTICS_STATION_GROUPS_QUERY
}